import { ISubuserApis } from "./ISubuserApis"
import ApiUtils from "../ApiUtils"
import { IPatientDetail } from "../../interfaces/patient/patients"

const SubUserUrls = {
	searchUserByUserId: (userId: string) => `/subusers/search?curefitUserId=${userId}&relationship=SELF`,
	searchUserByUHID: (uhid: string) => `/subusers/by_uhid/${uhid}`,
}

export default class SubuserApis implements ISubuserApis {
	getServiceUrl = (url: string) => "/subuser" + url
	searchPatientByUHID(uhid: string): Promise<any> {
		return ApiUtils.get(this.getServiceUrl(SubUserUrls.searchUserByUHID(uhid)))
	}
	searchPatientByUserId(userId: string): Promise<IPatientDetail[]> {
		return ApiUtils.get(this.getServiceUrl(SubUserUrls.searchUserByUserId(userId)))
	}
}
